














































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import Constants from '@/constants/constants';

import Modal, { ModalWidth } from '@/modules/shared/components/modal.component.vue';
import Button from '@/modules/shared/components/button.component.vue';
import Input from '@/modules/shared/components/input.component.vue';
import SpotlightText, { SpotlightTextType } from '@/modules/shared/components/spotlight-text.component.vue';

import RewardExchangeLine from '@/modules/loyalty/model/reward-exchange-line.model';
import Reward from '@/modules/loyalty/model/reward.model';
import { User } from '@/modules/user/model/user.model';

import ErrorMixin from '@/modules/shared/mixins/error.mixin.ts';


@Component({
    components: {
        Button,
        Modal,
        Input,
        SpotlightText,
    },
    computed: {
        ...mapGetters({
            profile: 'getProfile',
            rewardCartLines: 'getRewardCartLines',
            hasServerError: 'hasServerError',
            serverError: 'getServerError',
        }),
    },
    methods: {
        ...mapActions({
            rewardExchange: 'rewardExchange',
            fetchProfile: 'fetchProfile',
        }),
        ...mapMutations({
            clearRewardCart: 'clearRewardCart',
        }),
    },
})

export default class OrderModal extends Mixins<ErrorMixin> (ErrorMixin) {
    @Prop({ default: false }) private isOpen!: boolean;


    private inputTest = '';
    private toSend = {
        name: '',
        address: '',
        postalCode: '',
        town: '',
        state: '',
    };
    private constants = Constants;
    private modalWidth = ModalWidth;
    private rewardExchange!: any;
    private profile!: User;
    private hasServerError!: boolean;
    private serverError!: string;
    private rewardCartLines!: RewardExchangeLine[];
    private fetchProfile!: any;
    private clearRewardCart!: any;
    private rewardClaimed = false;
    public error = {
        name: '',
        address: '',
        town: '',
        postalCode: '',
        state: '',
    };
    private literals = {
        title: 'Datos necesarios para el envío del pedido',
        defaultPlaceholder: 'Escribe aquí',
        name: { label: 'Nombre completo de la persona que recibe el pedido' },
        address: { label: 'Dirección de envío del pedido' },
        cp: { label: 'Código postal', placeholder: '00000' },
        town: { label: 'Localidad' },
        state: { label: 'Provincia' },
    };


    get formComplete() {
        return (
            this.toSend.name !== '' &&
            this.toSend.address !== '' &&
            this.toSend.town !== '' &&
            this.toSend.postalCode !== '' &&
            this.toSend.state !== ''
        );
        return false;
    }

    get showSpotlight() {
        return (
            this.hasServerError ||
            this.rewardClaimed
        );
    }

    get spotlightText() {
        let text = 'Pedido tramitado con éxito';
        if ( this.hasServerError ) {
            text = this.serverError;
        }
        return text;
    }

    get spotlightType() {
        let type = '';
        if ( this.hasServerError ) {
            type = SpotlightTextType.Error;
        }
        return type;
    }


    private closeModal() {
        this.$emit('close-modal');
    }

    private checkErrors() {
        const emptyFieldMessage = 'Este campo no puede estar vacío';
        if ( this.toSend.name === '' ) {
            this.error.name = emptyFieldMessage;
        }
        if (this.toSend.address === '' ) {
            this.error.address = emptyFieldMessage;
        }
        if (this.toSend.town === '' ) {
            this.error.town = emptyFieldMessage;
        }
        if (this.toSend.postalCode === '' ) {
            this.error.postalCode = emptyFieldMessage;
        }
        if (this.toSend.state === '' ) {
            this.error.state = emptyFieldMessage;
        }
    }

    private sendForm() {
        this.checkErrors();
        if ( this.formComplete ) {
            this.rewardExchange({
                user: this.profile.id,
                ...this.toSend,
                rewardExchangeLine: [
                    ...this.rewardCartLines.map((line: RewardExchangeLine) => {
                        return {
                            reward: (line.reward as Reward).id,
                            quantity: line.quantity,
                        };
                    }),
                ],
            }).then((res: any) => {
                this.rewardClaimed = true;
                this.clearRewardCart();
                this.fetchProfile();
                setTimeout(() => {
                    this.closeModal();
                }, Constants.spotlightAppearTime);
            });
        }
    }

}
